import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    image: null,
    signature: null,
    thumbFingerprint: {
        data: null,
        image: null,
    },
};

const usersDataSlice = createSlice({
    name: 'data',
    initialState,
    reducers: {
        setImage(state, action) {
            state.image = action.payload;
        },
        setSignature(state, action) {
            state.signature = action.payload;
        },
        setThumbFingerprintData(state, action) {
            state.thumbFingerprint.data = action.payload;
        },
        setThumbFingerprintImage(state, action) {
            state.thumbFingerprint.image = action.payload;
        },
        removeImage(state) {
            state.image = null;
        },
        removeSignature(state) {
            state.signature = null;
        },
        removeThumbFingerprintData(state) {
            state.thumbFingerprint.data = null;
        },
        removeThumbFingerprintImage(state) {
            state.thumbFingerprint.image = null;
        },
        clearAllData(state) {
            state.image = null;
            state.signature = null;
            state.thumbFingerprint.data = null;
            state.thumbFingerprint.image = null;
        },
    },
});

// Export actions
export const {
    setImage,
    setSignature,
    setThumbFingerprintData,
    setThumbFingerprintImage,
    removeImage,
    removeSignature,
    removeThumbFingerprintData,
    removeThumbFingerprintImage,
    clearAllData,
} = usersDataSlice.actions;

// Export reducer
export default usersDataSlice.reducer;
